import { Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import JobsList from "./components/list/index";
import { Breadcrumbs, ToastContainer } from "../../components/Common";
import {useEffect} from "react";
import useAuthUser from "../../common/hooks/authUser";

const JobsPage = () => {
    const { user, isAdmin } = useAuthUser();
    const navigate = useNavigate();
    const pageTitle = isAdmin ? "Jobs" : "My Jobs";

    const onNewJobClicked = () => {
        navigate('/jobs/create');
    };

    useEffect(() => {
        document.title = pageTitle;
    }, [isAdmin]);

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs
                    title={pageTitle}
                >
                    <button
                        className="ms-4 btn btn-primary"
                        onClick={onNewJobClicked}
                    >CREATE NEW JOB</button>
                </Breadcrumbs>
                <JobsList
                    isAdmin={isAdmin}
                    userId={user.id}
                />
                <ToastContainer />
            </Container>
        </div>
    );
};

export default JobsPage;
